import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';
import { MiniGameEntityService } from '@views/pages/apps/games/mini-games/service/mini-game-entity.service';

@Injectable()
export class MiniGameResolver implements Resolve<boolean> {

    constructor(private miniGameEntityService: MiniGameEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.miniGameEntityService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.miniGameEntityService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }
}
